(function () {
  var checking = false;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function isGift(li) {
    return !!(li.properties && li.properties._gift);
  }

  function orphanUpdates(cart) {
    var updates = {};
    if (!cart.items || !cart.items.length) return updates;

    var hasParent = cart.items.some(function (li) {
      return !isGift(li);
    });

    cart.items.forEach(function (li) {
      if (!isGift(li)) return;
      if (!hasParent) {
        updates[li.key] = 0;
        return;
      }
      var max = parseInt(li.properties._gift_max || '1', 10) || 1;
      if (li.quantity > max) updates[li.key] = max;
    });
    return updates;
  }

  // resolves true if anything was stripped
  function clean() {
    return getCart()
      .then(function (cart) {
        var updates = orphanUpdates(cart);
        if (!Object.keys(updates).length) return false;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          return true;
        });
      })
      .catch(function () {
        return false;
      });
  }

  var CHECKOUT_SEL = '[name="checkout"], button[form*="cart"][type="submit"], a[href*="/checkout"]';

  document.addEventListener(
    'click',
    function (e) {
      if (checking) return;
      var el = e.target.closest && e.target.closest(CHECKOUT_SEL);
      if (!el || el.dataset.zpoCleared === '1') return;

      e.preventDefault();
      e.stopImmediatePropagation();
      checking = true;

      clean().then(function (stripped) {
        checking = false;
        if (stripped) {
          alert('Your free gifts need a product in the cart. Add one to continue.');
          window.location.href = '/cart';
          return;
        }
        el.dataset.zpoCleared = '1';
        el.click();
      });
    },
    true
  );

  function run() {
    clean().then(function (stripped) {
      if (stripped && window.location.pathname === '/cart') window.location.reload();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  document.addEventListener('cart:updated', run);
  document.addEventListener('cart:refresh', function (e) {
    if (e.detail && e.detail.zpo) return;
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) run();
  });
})();